// mobile header functions
if (pxco.breakpoints.value == 'small' || pxco.breakpoints.value == 'medium') {
	$('.site-header nav .has-dropdown > a').on('click', function () {
		var $parentLi = $(this).closest('li'),
			$cloned = $(this).clone(),
			$alreadyCloned = $parentLi.find('.cloned');

		event.preventDefault();

		if ($alreadyCloned.length != 0) {
			setTimeout(function() {
				$alreadyCloned.remove()
			}, 810);
			
		} else {
			$cloned.removeClass('has-dropdown');
			$('<li class="cloned"></li>').append($cloned).prependTo($parentLi.find('.dropdown'));
		}

		$('nav li.open').not($parentLi).removeClass('open');
		
		$parentLi.toggleClass('open');
	});
}

var navDropDown = document.querySelectorAll('.site-nav .has-dropdown');
for (var x = 0; x < navDropDown.length; x++) {
	var toggleNav = new pxco.Toogle(navDropDown[x].querySelector('a'), {
		target: navDropDown[x]
	});
}
